// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.taskComponent_wrap__-G2D3 {
	max-width: 960px;
	margin: 0 auto;
	padding: 1.25rem;
}
.taskComponent_header__\\+OLnq {
	display: flex;
	align-items: baseline;
	gap: 0.75rem;
}
.taskComponent_subtle__ExMkU {
	color: #6b7280;
	font-size: 0.95rem;
}

.taskComponent_table__mM6XN {
	display: flex;
	flex-direction: column;
	height: 100%;
	border: 1px solid #e5e7eb;
	border-radius: 12px;
	overflow: hidden;
}

.taskComponent_row__WZnQW {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	align-items: center;
	gap: 0.75rem;
	padding: 0.9rem 1rem;
	border-top: 1px solid #f3f4f6;
}
.taskComponent_head__Neauy {
	position: sticky;
	top: 0;
	background: #f9fafb;
	z-index: 1;
	font-weight: 600;
	border-top: none;
}
.taskComponent_nameCell__skGqO {
	font-weight: 600;
}

.taskComponent_tasksCard__T59gh {
	display: flex;
	flex-direction: column;
	height: 360px;
	border: 1px solid #e5e7eb;
	border-radius: 12px;
	background: #fff;
	overflow: hidden;
}

.taskComponent_tableBody__87dvC {
	flex: 1 1;
	overflow-y: auto;
	min-height: 0;
}

.taskComponent_actionsCol__ZtwbB {
	display: flex;
	gap: 0.5rem;
	justify-content: flex-end;
}
.taskComponent_iconBtn__QOBet {
	border: none;
	background: #f3f4f6;
	padding: 0.45rem 0.6rem;
	border-radius: 8px;
	cursor: pointer;
}
.taskComponent_iconBtn__QOBet:hover {
	background: #e5e7eb;
}
.taskComponent_iconBtn__QOBet.taskComponent_danger__6brk6 {
	background: #f04f4f;
}
.taskComponent_iconBtn__QOBet.taskComponent_danger__6brk6:hover {
	background: #e44848;
}

.taskComponent_completedText__BySrU {
	text-decoration: line-through;
	opacity: 0.6;
}

.taskComponent_iconBtnc__M\\+01C {
	border: none;
	background: #32fa5d;
	padding: 0.45rem 0.6rem;
	border-radius: 8px;
	cursor: pointer;
}
.taskComponent_iconBtnc__M\\+01C:hover {
	background: #46e62a;
}
.taskComponent_iconBtnNc__IpKzk {
	border: none;
	background: #d8d8d8;
	padding: 0.45rem 0.6rem;
	border-radius: 8px;
	cursor: pointer;
}
.taskComponent_iconBtnNc__IpKzk:hover {
	background: #ababab;
}
.taskComponent_iconBtnWFA__vcA6I {
	border: none;
	background: #ffaa3b;
	padding: 0.45rem 0.6rem;
	border-radius: 8px;
	cursor: pointer;
}
.taskComponent_iconBtnWFA__vcA6I:hover {
	background: #ff9c1b;
}

.taskComponent_badge__SNDt5 {
	padding: 0.2rem 0.5rem;
	border-radius: 999px;
	font-size: 0.8rem;
}
.taskComponent_badgeOpen__f8Wbj {
	background: #eef2ff;
	color: #3730a3;
}
.taskComponent_badgeDone__xIQcB {
	background: #dcfce7;
	color: #065f46;
}

.taskComponent_empty__Nprvz {
	padding: 1.5rem;
	text-align: center;
	color: #6b7280;
}

.taskComponent_overlay__pkVEM {
	position: fixed;
	inset: 0;
	background: rgba(0, 0, 0, 0.45);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 50;
}
.taskComponent_modal__VJQD2 {
	background: #fff;
	width: 100%;
	max-width: 40em;
	border-radius: 14px;
	padding: 1.1rem;
	box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
}
.taskComponent_field__XtMyJ {
	display: flex;
	flex-direction: column;
	gap: 0.4rem;
	margin: 0.7rem 0;
}
.taskComponent_field__XtMyJ input {
	padding: 0.55rem 0.7rem;
	border: 1px solid #e5e7eb;
	border-radius: 8px;
}

.taskComponent_modalActions__MFUI6 {
	margin-top: 1rem;
	display: flex;
	justify-content: flex-end;
	gap: 0.6rem;
}
.taskComponent_primary__DtzcO {
	background: #111827;
	color: #fff;
	border: none;
	padding: 0.55rem 0.9rem;
	border-radius: 8px;
	cursor: pointer;
}
.taskComponent_secondary__I\\+hpY {
	background: #f3f4f6;
	color: #111827;
	border: none;
	padding: 0.55rem 0.9rem;
	border-radius: 8px;
	cursor: pointer;
}
.taskComponent_dangerBtn__E16nR {
	background: #dc2626;
	color: #fff;
	border: none;
	padding: 0.55rem 0.9rem;
	border-radius: 8px;
	cursor: pointer;
}
.taskComponent_venueImage__mCA8T {
	width: 100%;
	max-height: 240px;
	object-fit: cover;
	border-radius: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/tasks/taskComponent.module.css"],"names":[],"mappings":"AAAA;CACC,gBAAgB;CAChB,cAAc;CACd,gBAAgB;AACjB;AACA;CACC,aAAa;CACb,qBAAqB;CACrB,YAAY;AACb;AACA;CACC,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,YAAY;CACZ,yBAAyB;CACzB,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,kCAAkC;CAClC,mBAAmB;CACnB,YAAY;CACZ,oBAAoB;CACpB,6BAA6B;AAC9B;AACA;CACC,gBAAgB;CAChB,MAAM;CACN,mBAAmB;CACnB,UAAU;CACV,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,aAAa;CACb,yBAAyB;CACzB,mBAAmB;CACnB,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,SAAO;CACP,gBAAgB;CAChB,aAAa;AACd;;AAEA;CACC,aAAa;CACb,WAAW;CACX,yBAAyB;AAC1B;AACA;CACC,YAAY;CACZ,mBAAmB;CACnB,uBAAuB;CACvB,kBAAkB;CAClB,eAAe;AAChB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;;AAEA;CACC,6BAA6B;CAC7B,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,mBAAmB;CACnB,uBAAuB;CACvB,kBAAkB;CAClB,eAAe;AAChB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,YAAY;CACZ,mBAAmB;CACnB,uBAAuB;CACvB,kBAAkB;CAClB,eAAe;AAChB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,YAAY;CACZ,mBAAmB;CACnB,uBAAuB;CACvB,kBAAkB;CAClB,eAAe;AAChB;AACA;CACC,mBAAmB;AACpB;;AAEA;CACC,sBAAsB;CACtB,oBAAoB;CACpB,iBAAiB;AAClB;AACA;CACC,mBAAmB;CACnB,cAAc;AACf;AACA;CACC,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,eAAe;CACf,QAAQ;CACR,+BAA+B;CAC/B,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,WAAW;AACZ;AACA;CACC,gBAAgB;CAChB,WAAW;CACX,eAAe;CACf,mBAAmB;CACnB,eAAe;CACf,2CAA2C;AAC5C;AACA;CACC,aAAa;CACb,sBAAsB;CACtB,WAAW;CACX,gBAAgB;AACjB;AACA;CACC,uBAAuB;CACvB,yBAAyB;CACzB,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,aAAa;CACb,yBAAyB;CACzB,WAAW;AACZ;AACA;CACC,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,uBAAuB;CACvB,kBAAkB;CAClB,eAAe;AAChB;AACA;CACC,mBAAmB;CACnB,cAAc;CACd,YAAY;CACZ,uBAAuB;CACvB,kBAAkB;CAClB,eAAe;AAChB;AACA;CACC,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,uBAAuB;CACvB,kBAAkB;CAClB,eAAe;AAChB;AACA;CACC,WAAW;CACX,iBAAiB;CACjB,iBAAiB;CACjB,mBAAmB;AACpB","sourcesContent":[".wrap {\r\n\tmax-width: 960px;\r\n\tmargin: 0 auto;\r\n\tpadding: 1.25rem;\r\n}\r\n.header {\r\n\tdisplay: flex;\r\n\talign-items: baseline;\r\n\tgap: 0.75rem;\r\n}\r\n.subtle {\r\n\tcolor: #6b7280;\r\n\tfont-size: 0.95rem;\r\n}\r\n\r\n.table {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\theight: 100%;\r\n\tborder: 1px solid #e5e7eb;\r\n\tborder-radius: 12px;\r\n\toverflow: hidden;\r\n}\r\n\r\n.row {\r\n\tdisplay: grid;\r\n\tgrid-template-columns: 1fr 1fr 1fr;\r\n\talign-items: center;\r\n\tgap: 0.75rem;\r\n\tpadding: 0.9rem 1rem;\r\n\tborder-top: 1px solid #f3f4f6;\r\n}\r\n.head {\r\n\tposition: sticky;\r\n\ttop: 0;\r\n\tbackground: #f9fafb;\r\n\tz-index: 1;\r\n\tfont-weight: 600;\r\n\tborder-top: none;\r\n}\r\n.nameCell {\r\n\tfont-weight: 600;\r\n}\r\n\r\n.tasksCard {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\theight: 360px;\r\n\tborder: 1px solid #e5e7eb;\r\n\tborder-radius: 12px;\r\n\tbackground: #fff;\r\n\toverflow: hidden;\r\n}\r\n\r\n.tableBody {\r\n\tflex: 1;\r\n\toverflow-y: auto;\r\n\tmin-height: 0;\r\n}\r\n\r\n.actionsCol {\r\n\tdisplay: flex;\r\n\tgap: 0.5rem;\r\n\tjustify-content: flex-end;\r\n}\r\n.iconBtn {\r\n\tborder: none;\r\n\tbackground: #f3f4f6;\r\n\tpadding: 0.45rem 0.6rem;\r\n\tborder-radius: 8px;\r\n\tcursor: pointer;\r\n}\r\n.iconBtn:hover {\r\n\tbackground: #e5e7eb;\r\n}\r\n.iconBtn.danger {\r\n\tbackground: #f04f4f;\r\n}\r\n.iconBtn.danger:hover {\r\n\tbackground: #e44848;\r\n}\r\n\r\n.completedText {\r\n\ttext-decoration: line-through;\r\n\topacity: 0.6;\r\n}\r\n\r\n.iconBtnc {\r\n\tborder: none;\r\n\tbackground: #32fa5d;\r\n\tpadding: 0.45rem 0.6rem;\r\n\tborder-radius: 8px;\r\n\tcursor: pointer;\r\n}\r\n.iconBtnc:hover {\r\n\tbackground: #46e62a;\r\n}\r\n.iconBtnNc {\r\n\tborder: none;\r\n\tbackground: #d8d8d8;\r\n\tpadding: 0.45rem 0.6rem;\r\n\tborder-radius: 8px;\r\n\tcursor: pointer;\r\n}\r\n.iconBtnNc:hover {\r\n\tbackground: #ababab;\r\n}\r\n.iconBtnWFA {\r\n\tborder: none;\r\n\tbackground: #ffaa3b;\r\n\tpadding: 0.45rem 0.6rem;\r\n\tborder-radius: 8px;\r\n\tcursor: pointer;\r\n}\r\n.iconBtnWFA:hover {\r\n\tbackground: #ff9c1b;\r\n}\r\n\r\n.badge {\r\n\tpadding: 0.2rem 0.5rem;\r\n\tborder-radius: 999px;\r\n\tfont-size: 0.8rem;\r\n}\r\n.badgeOpen {\r\n\tbackground: #eef2ff;\r\n\tcolor: #3730a3;\r\n}\r\n.badgeDone {\r\n\tbackground: #dcfce7;\r\n\tcolor: #065f46;\r\n}\r\n\r\n.empty {\r\n\tpadding: 1.5rem;\r\n\ttext-align: center;\r\n\tcolor: #6b7280;\r\n}\r\n\r\n.overlay {\r\n\tposition: fixed;\r\n\tinset: 0;\r\n\tbackground: rgba(0, 0, 0, 0.45);\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tz-index: 50;\r\n}\r\n.modal {\r\n\tbackground: #fff;\r\n\twidth: 100%;\r\n\tmax-width: 40em;\r\n\tborder-radius: 14px;\r\n\tpadding: 1.1rem;\r\n\tbox-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);\r\n}\r\n.field {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tgap: 0.4rem;\r\n\tmargin: 0.7rem 0;\r\n}\r\n.field input {\r\n\tpadding: 0.55rem 0.7rem;\r\n\tborder: 1px solid #e5e7eb;\r\n\tborder-radius: 8px;\r\n}\r\n\r\n.modalActions {\r\n\tmargin-top: 1rem;\r\n\tdisplay: flex;\r\n\tjustify-content: flex-end;\r\n\tgap: 0.6rem;\r\n}\r\n.primary {\r\n\tbackground: #111827;\r\n\tcolor: #fff;\r\n\tborder: none;\r\n\tpadding: 0.55rem 0.9rem;\r\n\tborder-radius: 8px;\r\n\tcursor: pointer;\r\n}\r\n.secondary {\r\n\tbackground: #f3f4f6;\r\n\tcolor: #111827;\r\n\tborder: none;\r\n\tpadding: 0.55rem 0.9rem;\r\n\tborder-radius: 8px;\r\n\tcursor: pointer;\r\n}\r\n.dangerBtn {\r\n\tbackground: #dc2626;\r\n\tcolor: #fff;\r\n\tborder: none;\r\n\tpadding: 0.55rem 0.9rem;\r\n\tborder-radius: 8px;\r\n\tcursor: pointer;\r\n}\r\n.venueImage {\r\n\twidth: 100%;\r\n\tmax-height: 240px;\r\n\tobject-fit: cover;\r\n\tborder-radius: 10px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `taskComponent_wrap__-G2D3`,
	"header": `taskComponent_header__+OLnq`,
	"subtle": `taskComponent_subtle__ExMkU`,
	"table": `taskComponent_table__mM6XN`,
	"row": `taskComponent_row__WZnQW`,
	"head": `taskComponent_head__Neauy`,
	"nameCell": `taskComponent_nameCell__skGqO`,
	"tasksCard": `taskComponent_tasksCard__T59gh`,
	"tableBody": `taskComponent_tableBody__87dvC`,
	"actionsCol": `taskComponent_actionsCol__ZtwbB`,
	"iconBtn": `taskComponent_iconBtn__QOBet`,
	"danger": `taskComponent_danger__6brk6`,
	"completedText": `taskComponent_completedText__BySrU`,
	"iconBtnc": `taskComponent_iconBtnc__M+01C`,
	"iconBtnNc": `taskComponent_iconBtnNc__IpKzk`,
	"iconBtnWFA": `taskComponent_iconBtnWFA__vcA6I`,
	"badge": `taskComponent_badge__SNDt5`,
	"badgeOpen": `taskComponent_badgeOpen__f8Wbj`,
	"badgeDone": `taskComponent_badgeDone__xIQcB`,
	"empty": `taskComponent_empty__Nprvz`,
	"overlay": `taskComponent_overlay__pkVEM`,
	"modal": `taskComponent_modal__VJQD2`,
	"field": `taskComponent_field__XtMyJ`,
	"modalActions": `taskComponent_modalActions__MFUI6`,
	"primary": `taskComponent_primary__DtzcO`,
	"secondary": `taskComponent_secondary__I+hpY`,
	"dangerBtn": `taskComponent_dangerBtn__E16nR`,
	"venueImage": `taskComponent_venueImage__mCA8T`
};
export default ___CSS_LOADER_EXPORT___;
